import { Suspense } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import CustomToast from "./Components/CustomToast/CustomToast";
import { routes } from "./Routes";
import "./assests/scss/AllComponents.scss";
import "./assests/scss/Responsive.scss";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import DefaultProtectedContainer from "./Containers/DefaultLayouts/DefaultProtectedContainer";
import { LoadingSpinner } from "./Components/AllInput/AllInput";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { msalConfig } from "./ReduxTool/Slice/Auth/MSConfig";
import Error404 from "./Components/ErrorPage/Error404";


const msalInstance = new PublicClientApplication(msalConfig);
const App: React.FC = () => (
  <>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
      <MsalProvider instance={msalInstance}>
        <Router>
          <Suspense fallback={<LoadingSpinner height="h-[100vh]" />}>
            <Routes>
              {routes.filter(route => !route.protected).map(({ path, Component }) => <Route key={path} path={path} element={<Component />} />)}
              <Route element={<DefaultProtectedContainer />}>
                {routes.filter(route => route.protected).map(({ path, Component }) => <Route key={path} path={path} element={<Component />} />)}
              </Route>
              <Route path="/*" element={<Error404 />} />
            </Routes>
          </Suspense>
        </Router>
      </MsalProvider>
    </GoogleOAuthProvider>
    <CustomToast ms={1800} />
  </>
);

export default App;

// Final commmit